import { render, staticRenderFns } from "./goodsPublish.vue?vue&type=template&id=d3640972&scoped=true&"
import script from "./goodsPublish.vue?vue&type=script&lang=js&"
export * from "./goodsPublish.vue?vue&type=script&lang=js&"
import style0 from "./goodsPublish.vue?vue&type=style&index=0&id=d3640972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3640972",
  null
  
)

export default component.exports